export const IDENTITY_KEY_KNOWN = 'known_identity'
export const IDENTITY_KEY_ANONYMOUS = 'anonymous_identity'
export const IDENTITY_VALUE = 'set'
export const GA_COOKIE_NAME = '_ga'
let gaCookieId: string | undefined

/**
 * Sets the GA cookie ID from environment config.
 * This should be called during initialization.
 * @param cookieId - The GA cookie identifier
 */
export const setGaCookieId = (cookieId?: string): void => {
  gaCookieId = cookieId
}

/**
 * Gets the GA cookie ID from environment config.
 * Returns undefined if not set.
 * @returns The GA cookie identifier or undefined
 */
export const getGaCookieId = (): string | undefined => {
  return gaCookieId
}

/**
 * Exported GA_COOKIE_ID for backward compatibility.
 * Note: This is evaluated at module load time and may be undefined until initializeSegment() is called.
 * For the current value, use getGaCookieId() instead.
 * @deprecated Use getGaCookieId() instead
 */
export const GA_COOKIE_ID: string | undefined = getGaCookieId()

export const FBP_COOKIE_NAME = '_fbp'
export const OPTANON_COOKIE_NAME = 'OptanonConsent'
export const OPTANON_DEFAULT_CONSENT = 'C0001:1,C0003:0,C0004:0,C0002:0'
export const PLATFORM_COOKIE_NAME = 'platform'
export const LAST_PLATFORM_COOKIE_NAME = 'last_platform'

export const EVENT_SEGMENT_LOADED = 'Segment Loaded'
export const EVENT_PAGE_LOADED = 'Page Loaded'
